import { ShopOnboardingID } from '@prisma/client';
import { useMutation } from '@tanstack/react-query';
import { skipOnboardingStep } from '../../services/business';
import { SkipOnboardingStepResponse } from '../../types/businesses';
import useUser from '../global/useUser';

interface Options {
  onSuccess?: (
    result: SkipOnboardingStepResponse | null,
  ) => void | Promise<void>;
  onError?: () => void | Promise<void>;
}

function useSkipOnboardingStep({ onSuccess, onError }: Options = {}) {
  const { user } = useUser();

  return useMutation({
    mutationFn: async (stepId: ShopOnboardingID) => {
      if (!user?.business?.id) return null;
      const result = await skipOnboardingStep(user.business.id, stepId);
      return result;
    },
    onSuccess,
    onError,
  });
}

export default useSkipOnboardingStep;
